/**
 * Each tech's own settings (docs/roadmap/user-settings.md). They aren't built
 * yet: Settings (ADR 0172) is the owner's, for everyone. Until they are, each
 * is its default here, for every tech, and what uses one asks for it through
 * `useUserSettings`. Once they're built, that reads the signed-in tech's own,
 * and nothing that uses them changes.
 */

export interface UserSettings {
  /**
   * How long a block's card is held still before it peeks (ADR 0193,
   * decision 2). The owner tried 80, 120 and 150 ms and chose 120; the
   * roadmap's choices are 80, 100, 120, 150 and 200 ms.
   */
  peekHoldMs: number;
}

/** Every tech's settings until per-user settings are built. */
export const USER_SETTING_DEFAULTS: Readonly<UserSettings> = {
  peekHoldMs: 120,
};

/** The signed-in tech's settings: for now, the defaults. */
export function useUserSettings(): Readonly<UserSettings> {
  return USER_SETTING_DEFAULTS;
}
